import React, { useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import { wsGetAll } from 'services/WService';
import { FormControl, FormControlLabel, InputLabel, MenuItem, Select, Switch } from '@material-ui/core';

//reemplazando valores de iniciales en estado

export default function ModalBureau(props) {
  const bureau = props.model;

  const [zones, setZones] = useState([]);
  const [divitions, setDivitions] = useState([]);
  // El switch va por dataForce: ModalBase lee el value de los campos y un checkbox siempre da "on"
  const [overrideMinValue, setOverrideMinValue] = useState(false);

  async function listZones() {
    let response = await wsGetAll('base/zone');
    if (response.success) setZones(response.data);
  }

  async function listDivitions() {
    let response = await wsGetAll('base/layer-divition');
    if (response.success) setDivitions(response.data);
  }

  useEffect(() => {
    if (bureau.open) {
      listZones();
      listDivitions();
      setOverrideMinValue(!!bureau.override_min_value);
    }
  }, [bureau.open]);

  return (
    <Modal
      title="Mesa"
      model={bureau}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      entity="base/bureau"
      dataForce={{ override_min_value: overrideMinValue ? 1 : 0 }}
      state
    >
      <TextField
        label="Código"
        type="text"
        name="code"
        margin="normal"
        fullWidth
        defaultValue={!!bureau ? bureau.code : ''}
        required
      />
      <TextField
        label="Descripción"
        type="text"
        name="description"
        margin="normal"
        fullWidth
        defaultValue={!!bureau ? bureau.description : ''}
        required
      />
      <FormControl fullWidth margin="normal" required>
        <InputLabel>Zona</InputLabel>
        <Select
          defaultValue={bureau.base_zone_id || ''}
          inputProps={{
            name: 'base_zone_id',
          }}
        >
          {zones.map((zone, i) => {
            return (
              <MenuItem value={zone.id} key={i}>
                {zone.description}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
      <FormControl fullWidth margin="normal" required>
        <InputLabel>Divición</InputLabel>
        <Select
          defaultValue={bureau.divition_id || ''}
          inputProps={{
            name: 'divition_id',
          }}
        >
          {divitions.map((divition, i) => {
            return (
              <MenuItem value={divition.id} key={i}>
                {divition.name}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
      <FormControl fullWidth margin="normal">
        <InputLabel>Tipo</InputLabel>
        <Select
          defaultValue={bureau.type || ''}
          inputProps={{
            name: 'type',
          }}
        >
          <MenuItem value="MULTIMARCA">MULTIMARCA</MenuItem>
          <MenuItem value="GOLOSINERO">GOLOSINERO</MenuItem>
        </Select>
      </FormControl>
      <FormControlLabel
        control={
          <Switch
            checked={overrideMinValue}
            onChange={(e) => setOverrideMinValue(e.target.checked)}
            color="primary"
          />
        }
        label="Usar monto mínimo propio"
      />
      <TextField
        label="Monto mínimo de pedido (S/)"
        type="number"
        name="order_min_value"
        margin="normal"
        fullWidth
        inputProps={{ step: '0.01', min: 0 }}
        defaultValue={bureau.order_min_value ?? ''}
        disabled={!overrideMinValue}
        required={overrideMinValue}
      />
    </Modal>
  );
}
